import React, { FC } from "react";

import { Button, Grid, IconButton, Toolbar, Typography } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

export const ToolbarCadastro: FC<{
  hide: () => void;
  title?: string;
  subtitle?: string;
  idForm: string;
}> = ({ hide, title, subtitle, idForm }) => (
  <Toolbar>
    <Grid container wrap="nowrap" alignItems="center">
      <Grid item>
        <IconButton
          edge="start"
          color="inherit"
          onClick={hide}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
      </Grid>
      <Grid item xs zeroMinWidth sx={{ ml: 1 }}>
        <Typography noWrap variant="h6">
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="caption" noWrap component="p">
            {subtitle}
          </Typography>
        )}
      </Grid>
      <Grid item>
        <Button
          form={idForm}
          sx={{ mr: 1 }}
          name="submit"
          type="submit"
          value="rascunho"
        >
          Rascunho
        </Button>
        <Button
          autoFocus
          color="primary"
          type="submit"
          form={idForm}
          variant="contained"
          disableElevation
          name="submit"
          value="submit"
        >
          Publicar
        </Button>
      </Grid>
    </Grid>
  </Toolbar>
);
